import { useState } from "react";
import { FaHeart } from "react-icons/fa";
import DonationForm from "./DonationForm";

const DonationCallout = () => {
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  return (
    <section className="bg-green-50 py-20 px-6">
      <div className="max-w-5xl mx-auto text-center rounded-xl shadow-sm border border-green-100 p-10 bg-white" data-aos="fade-up">
        <p className="italic text-sm text-green-600 mb-2 font-medium tracking-wide">
          Foundation Projects
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Make a Donation</h2>
        <p className="text-gray-600 text-md mb-8 max-w-2xl mx-auto">
          If you wish to support Shri Mataji’s legacy in Ahmedabad, please donate according to your means.
        </p>
        <button
          onClick={() => setShowModal(true)}
          className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white font-medium px-6 py-3 rounded-full transition"
        >
          <FaHeart className="text-white text-lg" />
          Donate
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4">
          <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative">
            <button
              onClick={() => {
                setShowModal(false);
                setSubmitted(false);
              }}
              className="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
            >
              ×
            </button>
            <h3 className="text-xl font-semibold text-green-800 mb-4 text-center">Fill this form to receive the UPI QR Code for donating</h3>
            {!submitted ? (
              <DonationForm onSuccess={() => setSubmitted(true)} />
            ) : (
              <div className="text-center space-y-4">
                <p className="text-green-700 font-semibold">✅ Thank you! Scan the QR to donate</p>
                <img src="/Donation.png" alt="QR Code" className="w-64 mx-auto border rounded shadow" />
                <p className="text-sm text-gray-600">Use any UPI app (PhonePe, GPay, Paytm, etc.)</p>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default DonationCallout;
